import api from "./api";
import Material, { MaterialDTO } from "@/model/material";

interface FaceListResponseInterface {
  meta: string;
  data: MaterialDTO[];
}
class MaterialApi extends api {
  constructor() {
    super();
    this.setup();
  }
  async index(parameters: { face_id: string, status?: number|null }): Promise<Material[]> {
    const response = await this.getHttp().get<FaceListResponseInterface>(
      "/materials",
      {
        params: parameters,
      }
    );

    if (response.data.data) {
      return response.data.data.map((item) => {
        return new Material(item);
      });
    }
    return [];
  }

  async changeStatus(material: Material): Promise<any> {
    const response = await this.getHttp().put<FaceListResponseInterface>(
      "/materials/update/status/" + material.id
    );

    return response.data;
  }
  async updateOrder(materials: Material[], face_id: number): Promise<any> {
    const response = await this.getHttp().put<FaceListResponseInterface>(
      "/materials/update/order",
      {
        material_ids: materials.map((item) => item.id),
        face_id,
      }
    );

    return response.data;
  }

  async create(material: Material): Promise<any> {
    const response = await this.getHttp().post<any>("/materials", material);

    return response.data;
  }

  async update(material: Material): Promise<any> {
    const response = await this.getHttp().put<any>(
      "/materials/" + material.id,
      material
    );

    return response.data;
  }
}
export default new MaterialApi();
